/**
 * Created by WengHaoping on 2017/6/5.
 */

/* const URL ='https://dev.weitianshi.cn/' */
import httpUrl from './config';
/* URL汇总 */
let weitianshi = '';
let weitianshiLine = '';
let systemName = httpUrl.systemName
let domainName = httpUrl.domainName
let dasai_test_url = httpUrl.dasai_test_url
let zst_test_url = httpUrl.zst_test_url
let systemDesc = httpUrl.systemDesc
let wxLogin_appid = httpUrl.wxLogin_appid
if (process.env.NODE_ENV === 'development') {
  weitianshi = httpUrl.devUrl + '/';
  weitianshiLine = httpUrl.devUrl + '/';
} else {
  weitianshi = httpUrl.proUrl + '/';
  weitianshiLine = httpUrl.proUrl + '/';
}
export default {
  cst_url: 'http://dasai.weitianshi.cn',
  /* 总地址,下载用的 */
  // weitianshi: 'https://pc.dev.weitianshi.cn/', // 下载用
  // weitianshiLine: 'https://pc.dev.weitianshi.cn/', // 上传
  // weitianshi: 'https://wts.weitianshi.cn/', // 上线接口下载用
  // weitianshiLine: 'https://wts.weitianshi.cn/', // 上线接口上传
  weitianshi: weitianshi,
  weitianshiLine: weitianshiLine,
  systemName: systemName,
  domainName: domainName,
  dasai_test_url,
  zst_test_url,
  systemDesc: systemDesc,
  wxLogin_appid: wxLogin_appid,
  openUrl: domainName + 'workbench/#/API/DD', // 一键尽调对外接口
  oneUrl: domainName + 'workbench/#/', // 一键尽调对内接口
  // 一键尽调跳转用接口
  // openUrl:'https://dev.weitianshi.cn/workbench/#/API/DD',

  investorMatch: 'api/project/InvestorMatch', // 一键尽调买家图谱

  /*
  * 上传用
  */

  /*
   * 登陆接口
   */
  returnQrCredential: '/api/auth/returnQrCredential', // (获取生成二维码的uuid接口)，返回值
  ajaxPolling: '/api/auth/ajaxPolling', // 获取登陆信息
  getWxosProjectData: '/api/v/project/getWxosProjectData', // 创建页面获取微信信息

  /*
   * 品牌配置
   */
  brandSet: '/api/configure/configure',


  /*
   * 服务超市
   */
  setNav: '/api/custom/wxos/navbar/list', // 导航权限列表
  setAppProgram: '/api/custom/wxos/identify', // 功能入口权限申请 、获取认证的权限信息
  editProgram: '/api/custom/wxos/permission', // 编辑权限
  companyType: '/api/category/company/type', // 公司类型
  serviceType: '/api/category/service/range', // 服务类别
  setService: '/api/market_services', // 获取服务列表 添加 编辑 详情
  delService: '/api/market_services/delete', // 批量删除服务
  marketOrderList: 'api/service_market/order/', // 订单列表
  marketOrderData: 'api/service_market/users/', // 单个人员下面的所有单子
  marketAllOrderPerson: 'api/service_market/managers/name_list', // 所有的跟单人员
  infoSave: '/api/service_store/info/', //店铺信息保存
  infoEdit: '/api/service_store/info/edit', //店铺信息获取
  /*
  /*
    * 广告投放
    */
  bannerMiniAll: '/api/ad/applications',
  submitAd: 'api/ad/app/',
  hotAppsAdd: '/api/custom/nav/hot',
  whiteListData: '/api/ad/nameList',
  viewNew: '/api/ad/msg/untreated', // 阅读消息
  miniPass: 'api/ad/applicationInfo/ad/', // 查看当前广告有多个通过的 小程序
  newsList: 'api/ad/msg/untreated',
  newsLists: 'api/ad/read/msg',
  newsCount: 'api/ad/msg/untreated/count', // 消息数量
  hasReads: 'api/ad/msg/treated', // 已读
  agreeOr: 'api/ad/msg/status/msg/', // 同意或者拒绝
  reads: 'api/ad/read/msg', // 阅读消息
  investmentList: 'api/wxos_my_investment/investment',
  /*
  * 项目批量上传
  */
  projectUpload: '/api/v/project/projectUpload?token=',
  /**
   *   早鸟票的接口
   */
  birdMemberData: 'api/has/members/wxos', // 选择所有会员体系的早鸟票
  single_mini_all_member: 'api/wxos/members', // 单个小程序下面所有的会员
  /**
   *  添加人脉圈
   */
  getFirstStatusList: 'api/category/getGroupIdentify', // 获取一级身份列表
  getSecondStatusList: 'api/category/getAllGroupIdentify', // 获取第二身份列表
  getAllIndustryData: 'api/category/all_industry', // 获取含有子集的领域
  submitConnects: 'api/user/register', // 提交人脉圈数据
  /*
  * 项目列表页
  */
  getNodeCount: '/api/project/getNodeCount', // 项目节点数量
  getAllNode: '/api/category/getAllNode', // 获取所有项目节点
  setScheduleOrder: '/api/category/setScheduleOrder', // 设置自定义进度标签
  deleteUpload: '/api/v/project/deleteUpload', // 删除批量上传的文件
  saveUpload: '/api/v/project/saveUpload', // 修改批量上传文件的绑定
  titleSift: '/api/v/project/titleSift', // 项目列表表头数据
  getProjectList: '/api/v/project/getProjectList', // 获取項目列表
  deleteProject: '/api/v/project/deleteProject', // 删除项目
  deleteSchedule: '/api/category/deleteSchedule', // 删除项目节点
  getCompetitionIndex: '/api/competition/getCompetitionIndex', // 获取大赛名称、阶段、评分指标
  deleteCompetitionIndex: '/api/competition/deleteCompetitionIndex', // 删除自定义的指标
  createCompetitionIndex: '/api/competition/createCompetitionIndex', // 自定义指标的创建和更新
  exportScoreByCompetition: '/api/competition/exportScoreByCompetition', // 导出大赛的统计评分数据，数据按照大赛的阶段分成不同的sheet表
  getCheckedColumn: '/api/project/getCheckedColumn', // 获取用户选中显示的字段
  editCheckedColumn: '/api/project/editCheckedColumn', // 修改用户选中显示的字段

  /*
  * 项目详情页
  */
  getProjectDetail: '/api/project/getProjectDetail', // 获取項目詳情
  deleteCoreTeam: '/api/v/project/deleteCoreTeam', // 删除核心成员
  deleteFinance: '/api/v/project/deleteFinance', // 删除历史融资
  deleteDevelop: '/api/v/project/deleteDevelop', // 删除里程碑
  deleteBrand: '/api/v/project/deleteBrand', // 删除品牌
  editProject: '/api/v/project/editProject', // 项目编辑、新建
  getOneCompany: '/api/dataTeam/getOneCompany', // 获取公司信息
  setProjectSchedule: '/api/project/setProjectSchedule', // 设置项目进度

  /*
  * 项目编辑页
  */
  getWxProjectCategory: '/api/category/getProjectCategory', // 编辑项目各种标签接口
  getArea: '/api/category/getArea', // 二级城市接口
  createStatusPro: '/api/category/createStatusPro', // 添加自定义运营状态
  createCustomTag: '/api/category/createCustomTag', // 添加自定义标签/个人,团队,人脉
  selectCompany: '/api/dataTeam/selectCompany', // 公司名称提示
  getFileType: '/api/category/getFileType', // 文件分组设置选项
  getAllFileType: '/api/category/getAllFileType', // 文件分组设置选项(全)
  createFileType: '/api/category/createFileType', // 添加文件分组设置
  updateProjectCompany: '/api/v/project/updateProjectCompany', // 更新公司,一键尽调的时候,是否将此公司作为自己的公司
  uploadProjectLogo: '/api/project/uploadProjectLogo?token=', // 项目log上传
  getProjectAllData: '/api/dataTeam/getProjectAllData', // 一键同步,获取同步信息
  createDataCustomTag: '/api/category/createDataCustomTag', // 一键同步,项目标签的添加

  /*
  * 一键尽调
  */
  getCrawlerCompany: '/api/dataTeam/getCrawlerCompany', // 一键尽调-公司(模糊匹配)
  selectCompanyByName: '/api/dataTeam/selectCompanyByName', // 一键尽调-公司(精准匹配)
  getCrawlerLeader: '/api/dataTeam/getCrawlerLeader', // 一键尽调-公司高管
  getCrawlerBrand: '/api/dataTeam/getCrawlerBrand', // 一键尽调-商标
  getCrawlerTeam: '/api/dataTeam/getCrawlerTeam', // 一键尽调-核心成员
  getCrawlerHistoryFinance: '/api/dataTeam/getCrawlerHistoryFinance',

  /*
  * 一键尽调加入项目库/联系项目方
  */
  getTransToProject: '/api/dataTeam/transToProject', // 加入项目库
  createServiceLog: '/api/user/createServiceLog', // 联系项目方

  /*
  * 一键尽调-历史融资
  */
  getCrawlerMilestone: '/api/dataTeam/getCrawlerMilestone', // 一键尽调-里程碑
  getCrawlerNews: '/api/dataTeam/getCrawlerNews', // 一键尽调-新闻
  getCrawlerCompeting: '/api/dataTeam/getCrawlerCompeting', // 一键尽调-竞品
  getCrawlerProject: '/api/dataTeam/getCrawlerProject', // 一键尽调-项目

  /*
  * 身份认证相关
  */
  getGroupIdentify: '/api/category/getGroupIdentify', // 身份类型列表
  setUserGroup: '/api/user/setUserGroup', // 设置身份类型
  saveUserIdentity: '/api/user/saveUserAuthentication', // 保存身份认证信息
  createUserProjectCase: '/api/v/project/createUserProjectCase', // 保存投资成功案例
  getUserGroupByStatus: '/api/user/getUserGroupByStatus', // 核对用户认证状态（用于判断用户是否能进入认证相关页面）
  uploadCard: '/api/user/uploadCard?token=', // 上传名片
  deleteCard: '/api/user/deleteCard', // 删除名片

  /*
  * 登录方面相关
  */
  authCaptcha: '/api/auth/authCaptcha', // 用户注册,登录获取验证码接口
  loginForCaptcha: '/api/auth/loginForCaptcha', // 用户注册/登录接口(验证码登录)
  loginForPassword: '/api/auth/loginForPassword', // 用户登录接口(账号密码)
  resetPasswordCaptcha: '/api/auth/resetPasswordCaptcha', // 重置密码获取验证码接口
  resetPassword: '/api/auth/resetPassword', // 重置密码接口
  bindTelephone: '/api/user/bindUser', // 绑定手机号码
  checkUserInfo: '/api/user/checkUserInfo', // 获取用户信息

  /*
  * 我的人脉
  */
  uploadConnectCard: '/api/user/uploadConnectCard?token=', // 人脉图片上传
  userTitleSift: '/api/user/userTitleSift', // 人脉列表表头
  getConnectUser: '/api/user/getConnectUser', // 获取人脉列表
  setConnectTag: '/api/user/setConnectTag', // 给人脉设置标签
  deleteConnectUser: '/api/user/deleteConnectUser', // .删除人脉
  createUserCard: '/api/user/createUserCard', // 添加人脉
  deleteConnectCard: '/api/user/deleteConnectCard', // 删除人脉名片(图片)
  getOneUserInfo: '/api/user/getOneUserInfo', // 人脉详情
  setJudgeAuth: '/api/user/setJudgeAuth', // 设置是否成为评委

  /*
  * 跟进记录
  */
  get_follow_records: '/api/project/get_follow_records', // 获取跟进记录总列表
  get_follow_record: '/api/project/get_follow_record', // 获取跟进记录单独
  getToInvestor: '/api/project/getToInvestor', // 获取跟进记录表头
  delete_follow_record: '/api/project/delete_follow_record', // 删除跟进记录
  match_my_relation: '/api/user/match_my_relation', // 模糊匹配我的人脉,添加跟进里是用
  add_follow_record: '/api/project/add_follow_record', // 添加跟进记录
  getProjectFollowList: '/api/v/project/getProjectFollowList', // 项目跟进记录列表
  getEnjoyedInvestorBasicInfo: '/api/user/getEnjoyedInvestorBasicInfo', // 获取联系方式机构

  /*
  * 文件管理
  */
  getProjectFiles: '/api/v/project/getProjectFiles', // 文件管理列表数据
  deleteAtUpload: '/api/v/project/deleteAtUpload', // bp文件软删除
  deleteAtFile: '/api/v/project/deleteAtFile', // 项目文件软删除
  download: '/api/v/project/download', // 文件下载
  uploadFile: '/api/v/project/uploadFile?token=', // 文件上传
  setFileType: '/api/v/project/setFileType', // 文件分组设置
  deleteFileType: '/api/v/project/deleteFileType', // 删除文件分组
  renameFileType: '/api/category/renameFileType', // 重命名文件分组

  /*
  * 意向项目(人脉详情右边)
  */
  getEnjoyProjectsGroup: '/api/v/project/getEnjoyProjectsGroup', // 意向项目归总(图表)
  getEnjoyProjects: '/api/v/project/getEnjoyProjects', // 意向项目列表,
  setEnjoyProjectSchedule: '/api/v/project/setEnjoyProjectSchedule', // 设置意向项目的跟进进度

  /*
  * 推荐项目(人脉详情右边)
  */
  getInvestorsMatchProjects: '/api/investors/getInvestorsMatchProjects', // 推荐项目
  exceptMatchAction: '/api/v/project/exceptMatchAction', // 移除买家图谱匹配(废弃)=====================
  removeInvestor: '/api/project/removeInvestor', // 移除买家图谱匹配

  /*
  * 意向投资人(项目详情右边)
  */
  getEnjoyedInvestors: '/api/project/getEnjoyedInvestors', // 意向投资人列表
  getEnjoyedInvestorsGroup: '/api/project/getEnjoyedInvestorsGroup', // 意向投资人归总(图表)

  /*
  * 买家图谱*(项目详情右边)
  */
  getProjectMatchInvestors: '/api/project/getProjectMatchInvestors', // 买家图谱列表
  getInvestorInfo: '/api/investors/getInvestorInfo', // 投资人详情

  /*
  * 项目推送
  */
  matchProject: '/api/v/project/matchProject', // 我的人脉-推送（模糊匹配我的项目(废弃)=====================
  getPushProjects: '/api/project/getPushProjects', // (项目推送，项目单选)投资人匹配到的项目
  pushUser: '/api/v/project/pushUser', // 我的人脉-推送（发送邮件）
  pushProject: '/api/v/project/pushProject', // 我的项目-推送(发送邮件)(废弃)=====================
  pushCount: '/api/v/project/pushCount', // 推送剩余次数
  getConnectUserSortByMatch: '/api/v/project/getConnectUserSortByMatch', // 推送项目时获取我的人脉(废弃)合二为一===============
  getAllConnectUserSortByMatch: '/api/v/project/getAllConnectUserSortByMatch', // 推送项目时获取全站人脉(废弃)合二为一=====================
  getPushInvestors: '/api/project/getPushInvestors', // 推送项目获取投资人
  recommendProject: '/api/project/recommendProject', // 帮我引荐
  getRecommendCount: '/api/project/getRecommendCount', // 项目引荐次数
  pushProjectToUsers: '/api/project/pushProjectToUsers', // 推送项目给多个投资人(人脉多选)

  /*
  * 使用微信二维码
  */
  getProjectQr: httpUrl.wxUrl + '/api/wx/getProjectQr', //
  getProjectQrOur: '/api/auth/getProjectQr',

  /*
  * 上传进度
  */
  uploadProgress: '/api/project/uploadProgress',

  /*
  * 邮箱加入项目库
  */
  importProject: '/api/message/importProject',

  /*
  * 上线后数据
  */
  getProjectViewData: '/api/project/getProjectViewData', // 上线后数据-浏览
  getProjectApplyData: '/api/project/getProjectApplyData', // 上线后数据-申请
  getProjectDetailsData: '/api/project/getProjectDetailsData', // 上线后数据-详情
  getProjectBPData: '/api/project/getProjectBPData', // 上线后数据-查看BP
  getProjectServiceData: '/api/project/getProjectServiceData', // 上线后数据-请求联系

  /*
  * 个人信息
  */
  getUserBasicInfo: '/api/user/getUserBasicInfo', // 获取个人信息
  getUserAuthenticateInfo: '/api/user/getUserAuthenticateInfo', // 获取认证信息
  updateUserInfo: '/api/user/updateUserInfo', // 个人信息编辑
  uploadUserImage: '/api/user/uploadUserImage?token=', // 上传头像
  deleteImage: '/api/user/deleteImage', // 删除头像
  uploadUserCardImage: '/api/user/uploadUserCardImage?token=', // 上传名片
  deleteCardImage: '/api/user/deleteCardImage', // 删除名片

  /*
  * 行为数据
  */
  getUserViewData: '/api/user/getUserViewData', // 行为数据-浏览数据
  getUserApplyData: '/api/user/getUserApplyData', // 行为数据-申请
  getUserDetailsData: '/api/user/getUserDetailsData', // 行为数据-查看详情
  getUserBPData: '/api/user/getUserBPData', // 行为数据-BP
  getUserServiceData: '/api/user/getUserServiceData', // 行为数据-请求联系

  /*
  * 评分统计
  */
  getProjectJudgeScoreList: '/api/project/getProjectJudgeScoreList', // 评委评分列表
  getProjectUserScoreList: '/api/project/getProjectUserScoreList', // 普通用户评分列表
  getScoreStatistics: '/api/project/getScoreStatistics', // 项目得分统计(最终评分,投资指数)
  getScoreStatisticsGroup: '/api/project/getScoreStatisticsGroup', // 项目指标平均分统计(图表用)
  editScoreShow: '/api/project/editScoreShow', // 修改项目评分背书展示
  exportProjectScoreByCompetition: '/api/competition/exportProjectScoreByCompetition', // 导出项目评分结果(下载)

  /*
  * 超级BP
  */
  uploadInquiryFile: '/api/superBp/uploadInquiryFile?token=', // BP问诊上传
  deleteInquiryFile: '/api/superBp/deleteInquiryFile', // bp问诊删除
  bpInquiry: '/api/superBp/bpInquiry', // 提交BP问诊
  bpCustom: '/api/superBp/bpCustom', // bp定制
  getBpFileSelected: '/api/superBp/getBpFileSelected', // 精选BP
  getIndustryAndStage: '/api/category/getIndustryAndStage', // 领域和阶段标签
  getBpPpt: '/api/superBp/getBpPpt', // bp预览
  getBpByIndustryAndStage: '/api/superBp/getBpByIndustryAndStage', // 通过领域和阶段筛选BP模板
  superBpDownload: '/api/superBp/superBpDownload', // 模板下载

  /*
  * 自动邮件
  */
  wtsProject: '/api/mobile/wtsProject', // 平台项目的项目详情
  scrapyProject: '/api/mobile/scrapyProject', // 爬虫怕取的项目详情
  createInterview: '/api/mobile/createInterview', // 项目约谈
  createSourceInterview: '/api/mobile/createSourceInterview', // 项目约谈_爬虫项目
  emailForBp: '/api/mobile/emailForBp', // 发送BP

  /*
  * 我的活动
  */
  uploadImage: '/api/activity/uploadImage?token=', // 我的活动上传图片
  deleteActivityImage: '/api/activity/deleteImage', // 删除图片
  getActivity: '/api/activity/getActivity', // 获取活动基本信息
  editActivity: '/api/activity/editActivity', // 创建 / 编辑活动
  getActivityApplyUser: '/api/activity/getActivityApplyUser', // 活动报名签到成员
  getActivityList: '/api/activity/getActivityList', // 活动列表
  deleteActivity: '/api/activity/deleteActivity', // 删除活动
  exportApplyUser: '/api/activity/exportApplyUser', // 导入报名名单模板
  exportApplyForm: '/api/activity/exportApplyForm', // 导出报名名单模板
  importApplyUser: '/api/activity/importApplyUser?token=', // register
  getSignQrCode: '/api/activity/getSignQrCode', // 获取签到二维码
  getActivityQrCode: '/api/activity/getActivityQrCode', // 获取报名二维码
  downloadQrCode: '/api/activity/downloadQrCode', // 下载签到二维码
  downloadActivityQrCode: '/api/activity/downloadActivityQrCode', // 下载报名二维码

  /*
  * 手机端入口
  */
  checkUserByInteInvestorId: '/api/user/checkUserByInteInvestorId', // 获取相关信息investor_id
  loginNonstop: '/api/auth/loginNonstop',

  /*
  * 我的赛事
  */
  getCompetitionList: '/api/competition/getCompetitionList', // 赛事列表
  deleteCompetition: '/api/competition/deleteCompetition', // 删除赛事
  getOneCompetition: '/api/competition/getOneCompetition', // 赛事详情
  editCompetition: '/api/competition/editCompetition', // 编辑赛事
  getCompNodeCount: '/api/project/getCompNodeCount', // 赛事阶段节点数量
  setProjectCompSchedule: '/api/project/setProjectCompSchedule', // 设置赛事阶段
  getJudgeList: '/api/competition/getJudgeList', // 评委列表
  editJudge: '/api/competition/editJudge', // 编辑评委
  getOneJudge: '/api/competition/getOneJudge', // 编辑评委
  competitionSetJudgeAuth: '/api/competition/setJudgeAuth', // 设置评分阶段
  deleteJudge: '/api/competition/deleteJudge', // 设置评分阶段
  getAllCompetition: '/api/competition/getAllCompetition', // 下拉框获取所有的赛事
  checkUserByMobile: '/api/user/checkUserByMobile', // 通过手机号查用户
  project: '/api/competition/recommend/project', // 活动匹配的项目资源
  investor: '/api/competition/recommend/investor', // 活动匹配的投资人资源
  comGetAllNode: '/api/competition/getAllNode', // 获取赛事的项目阶段
  comSetScheduleOrder: '/api/competition/setScheduleOrder', // 编辑赛事项目阶段
  comDeleteSchedule: '/api/competition/deleteSchedule', // 删除参赛项目阶段
  comInviteProject: '/api/competition/invite/project', // 赛事方邀请项目方

  /*
  * 项目库接口
  */
  projectLists: '/api/project/projectLists', // 全网项目
  searchProject: '/api/project/searchProject', // 项目搜索提示框
  tagList: '/api/category/tagList', // 项目库筛选项
  collect: '/api/project/collect', // 项目收藏
  collectList: '/api/project/collectList', // 收藏列表
  downloadBP: '/api/project/downloadBP', // 项目库bp文件下载
  info: '/api/project/info', // 项目详情
  getCompetitorCompany: '/api/project/getCompetitorCompany', // 相似公司
  specialSubject: '/api/project/subject/specialSubject', // 专栏列表
  specialSubjectProjectList: '/api/project/subject/specialSubjectProjectList', // 专栏下的项目列表
  userIntoLog: '/api/user/userIntoLog', // 记录入库时间
  getMorePartList: '/api/project/getMorePartList', // 查看更多
  projectInterview: '/api/project/interview/projectInterview', // 联系项目方
  sendBpToEmailBox: '/api/project/sendBpToEmailBox', // 发送bp到邮箱
  userActionLog: 'api/log/userActionLog', // 项目详情记录页面停留时间

  /*
  * 活动报名h5接口
  */
  show: '/api/activity/mobile/show', // 活动详情
  apply: '/api/activity/mobile/apply',  // 活动报名接口（用户已登录的情况）
  applyAndRegister: '/api/activity/mobile/applyAndRegister', // 活动报名+登录注册接口（用户未登录的情况）
  getarea: '/api/category/getarea', // 获取地区
  tag: '/api/category/tag', // 获取所有标签的接口
  applyUserList: '/api/activity/mobile/applyUserList', // 普通活动已报名用户列表
  applyProjectList: '/api/activity/mobile/applyProjectList', // 大赛活动报名的项目列表
  applyUserInfo: '/api/activity/mobile/applyUserInfo', // 报名成功后的用户、活动信息
  create: '/api/project/mobile/create', // 项目创建
  shareBus: '/api/wechat/shareBus', // 获取分享参数
  activityLog: '/api/activity/mobile/activityLog', // H5活动详情记录页面停留时间
  /*
  * 手推工具
  */
  manualPush: '/api/detailed',

  /*
  * 小程序定制
  */
  ask: '/api/custom/user/ask', // 定制咨询
  application: '/api/custom/user/application', // 获取用户管理的小程序列表
  banner: '/api/custom/banner', // banner列表
  delete: '/api/custom/banner/delete', // banner删除、禁用、启用
  qrcode: '/api/custom/banner/qrcode', // 获取banner对应的二维码， 这个接口暂时不用了，我也不删除他
  newQrcode: '/api/custom/qrcode/banner/', // 获取banner对应的二维码
  bannerInfo: '/api/custom/banner/info', // 编辑时获取banner的信息
  getProjectSimpleInfo: '/api/project/getProjectSimpleInfo', // 添加banner时选择项目的列表
  getActivitySimpleInfo: '/api/activity/getActivitySimpleInfo', // 添加banner选择的活动列表
  updateBanner: '/api/custom/banner/update', // banner编辑
  storeBanner: '/api/custom/banner/store', // banner添加
  getDatatables: '/api/custom/application/statistics', // 双创基础数据报表统计
  getTaskTypes: '/api/task/deal_users', // 任务订单审批管理系统-跟进人+任务类型
  getTaskData: '/api/task/summary', // 任务订单审批管理系统-数据统计
  getTaskList: '/api/task/ajaxTaskList', // 任务订单审批管理系统任务列表
  setTaskperson: '/api/task/save', // 任务列表-任务跟进
  getTl: '/api/wxos_my_investment/investment', // 获取机构
  customColumn: '/api/custom/column', // 自定义专栏的列表
  deleteColumn: '/api/custom/column/delete', // 删除 禁用 启用 专栏
  storeColumn: '/api/custom/column/store', // 创建专栏
  updateColumn: '/api/custom/column/update', // 专栏编辑保存
  getEditColumn: '/api/custom/column/edit', // 获取专栏的信息用于编辑
  removeProject: '/api/custom/column/remove/project', // 专栏下已添加的项目取消添加
  getAllProject: '/api/custom/all/project', // 获取所有公开审核通过的项目
  customProject: '/api/custom/column/project', // 专栏已经添加的项目
  setColumnSort: '/api/custom/column/project/setSort', // 设置专栏项目的排序
  isNiceColumn: '/api/custom/column/isEnableCreateSelectedOrNewsColumn', // 判断是否能创建、编辑精选或者最新的专栏
  addedProject: '/api/custom/column/addedProject', // 创建和编辑页显示的已添加的项目列表
  customNavList: '/api/custom/nav/list', // 获取所有的功能入口列表
  columnsList: '/api/custom/nav/columns', //首页专栏列表
  columnsSort:'/api/custom/nav/sort/columns', //专栏排序
  columnsHide: '/api/custom/nav/hide/columns/', //专栏隐藏/显示
  customNavApply: '/api/custom/nav/apply', // 添加功能入口接口
  customNavRemove: '/api/custom/nav/remove', // 移除功能入口
  storeCustomNav: '/api/custom/nav/store', // 创建自定义功能入口
  editCustomNav: '/api/custom/nav/update', // 编辑自定义功能入口
  getCustomNavEdit: '/api/custom/nav/edit', // 编辑时获取功能入口的信息
  deleteCustom: '/api/custom/nav/delete', // 删除自定义的功能入口
  hideNav: '/api/custom/nav/hide', // 隐藏/显示功能入口
  userlist: '/api/custom/dashboard/userlist', // 小程序用户列表
  projectlist: '/api/custom/dashboard/projectlist', // 小程序项目列表
  activitylist: '/api/custom/dashboard/activitylist', // 小程序活动列表
  userlog: '/api/custom/dashboard/userlog', // 用户足迹
  // 萧山招商
  industryXs: '/api/xiaoshan/industryXs', // 萧山八大产业
  industryHot: '/api/xiaoshan/industryHot', // 产业热度
  industryPattern: '/api/xiaoshan/industryPattern', // 产业格局
  industryCityRank: '/api/xiaoshan/industryCityRank/', // 产业分布
  industryTrend: '/api/xiaoshan/industryTrend', // 产业趋势
  industryDetail: '/api/xiaoshan/industryDetail/', // 细分产业
  getXiaoShanProjectList: '/api/xiaoshan/projectList', // 招商项目
  getCustomIndustry: '/api/custom/nav/getCustomIndustry', // 招商编辑获取领域标签
  allArticle: '/api/custom/article/all', // 小程序选的所有文章
  articleLibrary: 'api/custom/article/library',// 文章素材库
  articleReprint: 'api/custom/article/reprint', //文章转载或取消转载
  articleDetails:'api/custom/article/details',//文章素材查看详情  
  createArticle: '/api/custom/article/create', // 文章创建
  columnArticle: '/api/custom/column/article', // 专栏列表下的文章
  updateArticle: '/api/custom/article/update', // 文章编辑
  editArticle: '/api/custom/article/edit', // 获取要编辑的文章信息
  deleteArticle: '/api/custom/article/delete', // 删除文章
  publishArticle: '/api/custom/article/publish', // 文章发布
  setSortArticle: '/api/custom/column/article/setSort', // 专栏中的文章排序
  keywordCreate: '/api/category/keyword/create', // 创建关键字
  getKeywords: '/api/category/keywords', // 获取/搜索关键字
  getInvest_tag: '/api/category/industry', // 获取最新获投的行业领域
  setCustom_tag: '/api/category/latest_investment/custom/industry/', // 更新自定义的二级领域 (最新获投)，添加自定义的二级领域
  xxx: 'xxx',

  // 小程序后台管理
  getAdmins: '/api/microTeam/application/', // 获取该小程序下所有成员列表 、添加成员、// 获取当前小程序下的角色（身份）列表 、添加角色
  getpermissions: 'api/microTeam/admins/', // 当前用户小程序管理后台的权限
  getAllpermssions: '/api/microTeam/permissions', // 获取系统所有权限列表
  howTime: '/api/app/expired', // 检查小程序授权是否到期
  updateRoles: '/api/microTeam/roles/', // 更新角色信息
  deleteMember: '/api/microTeam/admins/', // 权限管理-删除成员

  //微天使小程序后台优化:会员
  membersList: '/api/custom/members',//会员类型列表,添加会员类型
  membersOrders: '/api/custom/members/payments/records',//会员订单列表
  getMembers: '/api/wxos/members',//某个小程序下的会员体系
  searchUser: '/api/custom/members/search/user',//根据手机号搜索用户

  //微天使小程序后台优化:活动
  adminExportApplyForm: weitianshi + 'api/admin/activity/adminExportApplyForm',//活动报名名单模板下载
  newImportApplyUser: weitianshi + 'api/admin/activity/importApplyUser',//活动列表导入报名名单
  newExportApplyUser: weitianshi + 'api/admin/activity/exportApplyUser',//活动列表导出报名名单

  //微天使小程序后台优化:项目列表
  projectDownload: weitianshi + 'api/admin/project/download',//后台项目列表商业计划书下载
  getQR: '/api/custom/members/wxos_page/qr',//获取二维码图片
  // 服务超市添加服务增加线上支付
  onLinePayService: 'api/category/currencies',
  // 大屏
  dataScreen_userAdd:'/api/statistics/new_user', // 新增用户
  dataScreen_userCount: '/api/statistics/total_user', // 用户统计
  dataScreen_industry: '/api/statistics/cate_project', // 行业分类项目
  dataScreen_newPro: '/api/statistics/new_project', // 最新项目
  dataScreen_activity:'/api/statistics/mini_program', // 活跃度
  dataScreen_map_dot:'/api/statistics/map_dot/', // 地图点坐标
  dataScreen_map:'/api/statistics/company_statistics', // 地图数据(军民融合)
  dataScreen_zc:'api/admin/zst/organ/rank', // 地图数据(众创)
  dataScreen_firmType: '/api/statistics/company_type', // 企业类型数据
  dataScreen_firmData:'/api/statistics/service_market', // 企业服务统计图
  dataScreen_knowledge:'/api/statistics/ip_type', // 知识产权类型
  dataScreen_matchActivity: '/api/statistics/activity', // 赛事活动
  dataScreen_space:'/api/statistics/space', // 众创空间
  dataScreen_organ:'/api/statistics/organ', // 服务机构
  dataScreen_space_area:'/api/statistics/space_area', // 办公空间
  dataScreen_invest_pro: '/api/statistics/invest_project', // 投融对接
  selfDefineEnter: '/api/custom/nav/icon',
  getAllAreaData: '/api/category/allArea',
  getScreenRange: 'api/admin/screen/range', //获取大屏列表
  screenAlgorithm: 'api/admin/screen/range/algorithm', //展示数据计算
  postAddScreen: 'api/admin/data_screen/',
  getScreenDet: 'api/admin/data_screen/', //数据大屏详情
  addAgriculture: 'api/admin/agriculture_screen/',
  getagricultureList: 'api/admin/agriculture/screen/questions',
  getScreenActivity: 'api/admin/agriculture/screen/activities',
  getScreenColumnList: '/api/admin/agriculture/screen/columns/',
  getScreenService: 'api/admin/agriculture/screen/services',
  demandsTypes: '/api/custom/market/demands/types', //需求市场类型分类列表
  setWXRange: '/api/custom/market/demands/set/range', //设置小程序范围
  demandList:'/api/custom/market/demands', //需求列表
  demandShow: '/api/custom/market/demands/toggle/show', //批量显示&隐藏
  addDemand:'/api/custom/market/demands/add/types', //自定义分类添加
  upDemandSuperAdm: '/api/custom/market/demands/set/global', //上传到超管审核
  saveDemand: '/api/custom/market/demands/types/save', //保存类型
  // 小程序换肤
  pageStyle: 'api/admin/wx/style', //B端小程序风格样式
  ToggleMoreBtn:'/api/custom/toggle/more/btn', //设置小程序首页"更多"
};



// WEBPACK FOOTER //
// ./src/api/url.js